import Vue from 'vue'
import App from '@/views/App.vue'
import store from '@/plugins/store/index'
import router from '@/plugins/router'
import i18n from '@/i18n'
import { installLocaleCrossAppSync } from '@/i18n/locale-sync'
import '@/plugins/element'
import '@/plugins/axios'
import '@/assets/style/index.scss'
import PageNav from '@/components/PageNav'
import LanguageSwitcher from '@/components/LanguageSwitcher'
import { filterToLabel, filterToDate, filterToYuan, filterToEmpty } from '@/utils/filters'

Vue.config.productionTip = false

Vue.filter('filterToLabel', filterToLabel)
Vue.filter('filterToDate', filterToDate)
Vue.filter('filterToYuan', filterToYuan)
Vue.filter('filterToEmpty', filterToEmpty)

Vue.component('page-nav', PageNav)
Vue.component('language-switcher', LanguageSwitcher)

const vueInstance = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.vbus = vueInstance
installLocaleCrossAppSync()
